<template>
  <div>
    <v-row align="center">
      <v-col
        :align="isMobile ? 'left' : 'right'"
        cols="12"
        xs="12"
        sm="12"
        md="3"
        lg="2"
        xl="2"
      >
        <p style="font-weight: bold; margin-bottom: 0!important; font-size: 15px;">{{title}}:</p>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="8"
        lg="8"
        xl="8"
      >
        <div
          style="background-color: #fafafa;"
          class="pa-3"
        >
          <!-- Delete variation button -->
          <div style="text-align: right;">
            <v-btn
              @click="disable_variation"
              icon
              color="grey"
              small
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <!-- Variation name -->
          <div>
            <v-row>
              <v-col :cols="isMobile ? '12' : '10'">
                <RowTextField
                  :is_required="true"
                  title="Name"
                  :value="variation_name"
                  :need_field_spacing="false"
                  @input="update_variation"
                  @change="variation_change"
                ></RowTextField>
              </v-col>
              <v-col
                cols="2"
                v-if="!isMobile"
              >
              </v-col>
            </v-row>
          </div>
          <!-- Variation options -->
          <div
            v-for="(item, i) in variation_options"
            :key="i"
          >
            <v-row align="end">
              <v-col cols="10">
                <RowTextField
                  :is_required="true"
                  :title="`Option ${i+1}`"
                  :value="item.name"
                  :need_field_spacing="false"
                  @input="update_variation_option($event, i)"
                ></RowTextField>
              </v-col>
              <v-col cols="2">
                <v-btn
                  v-if="i > 0"
                  color="grey"
                  icon
                  @click="delete_variation_option(i)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <!-- Add option variation 1 button -->
          <div
            style="text-align: center;"
            class="mt-3"
            v-if="variation_options.length < 20"
          >
            <v-btn
              @click="add_variation"
              color="primary"
              depressed
              class="white--text"
              style="text-transform: capitalize;"
            >Add Option ({{variation_options.length}} / 20)</v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RowTextField from '../components/RowTextField.vue';

export default {
  props: {
    title: String,
    variation_name: String,
    variation_options: Array,
  },
  components: {
    RowTextField
  },
  methods: {
    disable_variation() {
      this.$emit('disable_variation');
    },
    update_variation() {
      this.$emit('update_variation');
    },
    variation_change() {
      this.$emit('variation_change');
    },
    delete_variation_option(i) {
      this.$emit('delete_variation_option', i);
    },
    update_variation_option(value, index) {
      this.$emit('update_variation_option', { value: value, index: index });
    },
    add_variation() {
      this.$emit('add_variation');
    }
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
        case "xl":
          return false;
        default:
          return false;
      }
    },
  },
}
</script>

<style scoped>
.form-spacing {
  margin-top: 25px;
  margin-bottom: 25px;
}
</style>